export default __webpack_public_path__ + "static/media/songCompassWhite.36a2de94.svg";